import { type ReactNode } from 'react';

export const Step = ({
  illustration,
  children,
  actions,
}: {
  illustration: ReactNode;
  children: ReactNode;
  actions: ReactNode;
}) => {
  return (
    <div className="bg-background-secondary-default flex h-full">
      <div className="flex-1 p-32">{illustration}</div>
      <div className="bg-background-primary-default flex flex-1 flex-col">
        <div className="flex-1 p-32">{children}</div>
        <div className="separator" />
        <div className="flex flex-row-reverse gap-16 p-16 px-32">{actions}</div>
      </div>
    </div>
  );
};
